<template>
  <d2-container>
    <template slot="header">
      <el-input
        v-model="listQuery.name"
        clearable
        size="small"
        placeholder="模特名称"
        style="width: 220px; margin-right: 10px;"
        @keyup.enter.native="loadList"
      ></el-input>
      <el-select
        v-model="listQuery.status"
        clearable
        size="small"
        placeholder="状态"
        style="width: 120px; margin-right: 10px;"
      >
        <el-option label="全部" :value="null"></el-option>
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="loadList">搜索</el-button>
      <el-button size="small" icon="el-icon-refresh" @click="resetSearch">重置</el-button>
      <el-button type="primary" size="small" icon="el-icon-circle-plus" @click="openCreate">新增模特</el-button>
    </template>

    <el-alert
      title="落地页只提交模特 ID。展示图仅用于用户选择，制作参考图仅由服务端带入制作流程；创建任务时服务端会重新查询启用状态。"
      type="info"
      :closable="false"
      show-icon
      style="margin-bottom: 14px;"
    ></el-alert>

    <el-table v-loading="loading" :data="models" border stripe size="small">
      <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
      <el-table-column label="展示图" width="116" align="center">
        <template slot-scope="scope">
          <el-image
            class="model-preview"
            :src="scope.row.displayImageUrl || scope.row.referenceImageUrl"
            :preview-src-list="[scope.row.displayImageUrl || scope.row.referenceImageUrl]"
            fit="cover"
          >
            <div slot="error" class="image-error">加载失败</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column label="制作参考图" width="116" align="center">
        <template slot-scope="scope">
          <el-image
            class="model-preview"
            :src="scope.row.productionImageUrl || scope.row.referenceImageUrl"
            :preview-src-list="[scope.row.productionImageUrl || scope.row.referenceImageUrl]"
            fit="cover"
          >
            <div slot="error" class="image-error">加载失败</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="模特名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="description" label="风格说明" min-width="220" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sortOrder" label="排序" width="90" align="center"></el-table-column>
      <el-table-column label="状态" width="100" align="center">
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.status === 1"
            @change="toggleStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="170" align="center"></el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="openEdit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @closed="clearValidation">
      <el-form ref="form" :model="form" :rules="rules" label-width="105px">
        <el-form-item label="模特名称" prop="name">
          <el-input v-model="form.name" maxlength="128" show-word-limit placeholder="如：轻奢棚拍"></el-input>
        </el-form-item>
        <el-form-item label="展示图" prop="displayImageUrl">
          <upload-image
            v-model="form.displayImageUrl"
            :max="1"
            :width="180"
            :show-tips="false"
          ></upload-image>
        </el-form-item>
        <el-form-item label="制作参考图" prop="productionImageUrl">
          <upload-image
            v-model="form.productionImageUrl"
            :max="1"
            :width="180"
            :show-tips="false"
          ></upload-image>
          <div class="field-tip">仅作为服务端制作输入，不展示给落地页用户</div>
        </el-form-item>
        <el-form-item label="风格说明">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            maxlength="512"
            show-word-limit
            placeholder="可选，展示给体验页用户"
          ></el-input>
        </el-form-item>
        <el-row :gutter="12">
          <el-col :span="12">
            <el-form-item label="排序">
              <el-input-number
                v-model="form.sortOrder"
                :min="0"
                :step="10"
                controls-position="right"
                style="width: 100%;"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="启用">
              <el-switch v-model="form.enabled"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  addLandingExperienceModel,
  getLandingExperienceModelList,
  updateLandingExperienceModel
} from '@/api/merchant/service/landingExperience'
import UploadImage from '@/components/uploadImage/index.vue'

export default {
  name: 'landingExperienceModelManager',
  components: { UploadImage },
  data () {
    const httpsUrl = (rule, value, callback) => {
      if (!value || !/^https:\/\/[^\s]+$/i.test(value.trim())) {
        callback(new Error('请输入有效的 HTTPS 图片地址'))
        return
      }
      callback()
    }
    return {
      loading: false,
      saving: false,
      models: [],
      listQuery: {
        name: '',
        status: null
      },
      dialogVisible: false,
      dialogTitle: '新增体验模特',
      form: this.defaultForm(),
      rules: {
        name: [
          { required: true, message: '请输入模特名称', trigger: 'blur' }
        ],
        displayImageUrl: [
          { required: true, validator: httpsUrl, trigger: 'change' }
        ],
        productionImageUrl: [
          { required: true, validator: httpsUrl, trigger: 'change' }
        ]
      }
    }
  },
  created () {
    this.loadList()
  },
  methods: {
    defaultForm () {
      return {
        id: null,
        name: '',
        displayImageUrl: '',
        productionImageUrl: '',
        referenceImageUrl: '',
        description: '',
        sortOrder: 100,
        enabled: true
      }
    },
    normalizeList (res) {
      if (Array.isArray(res)) return res
      if (res && Array.isArray(res.records)) return res.records
      if (res && Array.isArray(res.list)) return res.list
      return []
    },
    loadList () {
      this.loading = true
      const query = {
        name: (this.listQuery.name || '').trim()
      }
      if (this.listQuery.status !== null && this.listQuery.status !== undefined) {
        query.status = this.listQuery.status
      }
      return getLandingExperienceModelList(query)
        .then(res => {
          this.models = this.normalizeList(res)
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetSearch () {
      this.listQuery = { name: '', status: null }
      this.loadList()
    },
    openCreate () {
      this.dialogTitle = '新增体验模特'
      this.form = this.defaultForm()
      this.dialogVisible = true
    },
    openEdit (row) {
      this.dialogTitle = '编辑体验模特'
      this.form = {
        id: row.id,
        name: row.name || '',
        displayImageUrl: row.displayImageUrl || row.referenceImageUrl || '',
        productionImageUrl: row.productionImageUrl || row.referenceImageUrl || '',
        referenceImageUrl: row.referenceImageUrl || '',
        description: row.description || '',
        sortOrder: Number(row.sortOrder) || 0,
        enabled: row.status === 1
      }
      this.dialogVisible = true
    },
    clearValidation () {
      if (this.$refs.form) this.$refs.form.clearValidate()
    },
    payloadFromForm () {
      return {
        id: this.form.id,
        name: (this.form.name || '').trim(),
        displayImageUrl: (this.form.displayImageUrl || '').trim(),
        productionImageUrl: (this.form.productionImageUrl || '').trim(),
        // Controller 兼容旧字段；新管理端以两个显式字段为准。
        referenceImageUrl: (this.form.productionImageUrl || '').trim(),
        description: (this.form.description || '').trim(),
        sortOrder: Number(this.form.sortOrder) || 0,
        status: this.form.enabled ? 1 : 0
      }
    },
    save () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        const payload = this.payloadFromForm()
        this.saving = true
        const request = payload.id
          ? updateLandingExperienceModel(payload)
          : addLandingExperienceModel(payload)
        request.then(() => {
          this.$message.success(payload.id ? '模特已更新' : '模特已创建')
          this.dialogVisible = false
          this.loadList()
        }).finally(() => {
          this.saving = false
        })
      })
    },
    toggleStatus (row) {
      const payload = {
        id: row.id,
        name: row.name,
        displayImageUrl: row.displayImageUrl || row.referenceImageUrl,
        productionImageUrl: row.productionImageUrl || row.referenceImageUrl,
        referenceImageUrl: row.productionImageUrl || row.referenceImageUrl,
        description: row.description || '',
        sortOrder: Number(row.sortOrder) || 0,
        status: row.status === 1 ? 0 : 1
      }
      updateLandingExperienceModel(payload).then(() => {
        this.$message.success(payload.status === 1 ? '已启用' : '已停用')
        this.loadList()
      })
    }
  }
}
</script>

<style scoped>
.model-preview {
  width: 72px;
  height: 72px;
  border-radius: 4px;
}

.image-error {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
  background: #f5f7fa;
}

.field-tip {
  margin-top: 6px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
